import Vue from 'vue';

Vue.config.productionTip = false;

const devProdPath = function (devPath, prodPath) {
    return window.location.port == '4000' ? devPath : prodPath;
};

Vue.component('chevron-down', {
    template: `
    <svg width="12" height="20" viewBox="0 0 12 20" version="1.1" aria-hidden="true" class="sst-svg-icon sst-svg-icon--ic-expand-more">
      <path d="M10.59,6.295L6,10.875l-4.59-4.58L0,7.705l6,6l6-6L10.59,6.295z" fill-rule="evenodd"></path>
    </svg>
  `,
});

Vue.component('chevron-right', {
    template: `
    <svg width="7.41" height="20" viewBox="0 0 7.41 20" version="1.1" aria-hidden="true" class="sst-svg-icon sst-svg-icon--ic-chevron-right">
      <path d="M1.41,4L0,5.41L4.58,10L0,14.59L1.41,16l6-6L1.41,4z" fill-rule="evenodd"></path>
    </svg>
  `,
});

Vue.component('chevron-left', {
    template: `
    <svg width="7.41" height="20" viewBox="0 0 7.41 20" version="1.1" aria-hidden="true" class="sst-svg-icon sst-svg-icon--ic-chevron-left svg-icon">
      <path d="M7.41,5.41L6,4l-6,6l6,6l1.41-1.41L2.83,10L7.41,5.41z" fill-rule="evenodd"></path>
    </svg>
  `,
});

Vue.component('arrow-left', {
    template: `
    <svg width="16" height="20" viewBox="0 0 16 20" version="1.1" aria-hidden="true" class="sst-svg-icon sst-svg-icon--ic-arrow-back svg-icon">
      <path d="M16,9H3.83l5.59-5.59L8,2l-8,8l8,8l1.41-1.41L3.83,11H16V9z" fill-rule="evenodd"></path>
    </svg>
  `,
});

Vue.component('slide-nav', {
    props: {
        url: {
            type: String,
            default: window.location.href,
        },
        menuId: {
            type: String,
            default: '',
        },
        showMobileHeader: {
            type: Boolean,
            default: false,
        },
    },
    template: `
    <div>
      <div
        v-if="showMobileHeader"
        :class="{
          'slide-nav-header': true,
          'slide-nav-header--expanded': expanded
        }"
      >
        <span>Каталог</span>
        <button
          class="slide-nav-header__button"
          @click="expanded = !expanded"
        >
          <chevron-down/>
        </button>
      </div>
      <div
        ref="navWrapper"
        class="slide-nav"
        :class="{
          'slide-nav--collapsed': showMobileHeader && !expanded,
          'slide-nav--expanded': showMobileHeader && expanded,
        }"
      >
        <transition
          :name="transitionName"
          @enter="calcHeight"
        >
          <ul
            v-if="Object.keys(activeItem).length"
            ref="menuItemList"
            key="not-root"
            class="slide-nav__list"
          >
            <transition
              :name="transitionName"
              @enter="calcHeight"
            >
              <li :key="activeItem.id" class="slide-nav__menu-item slide-nav__menu-item--only">
                <div
                  class="slide-nav__head"
                  @click="setActiveItem(activeItem.parentId, 'slide-out-nav')"
                >
                  <button
                    class="slide-nav__button slide-nav__button--left"
                  >
                    <chevron-left/>
                  </button>
                  {{activeItem.displayName}}
                </div>
                <ul
                  v-if="activeItem.children.length"
                  class="slide-nav__list"
                >
                  <li
                    v-for="child in activeItem.children"
                    :class="{
                      'slide-nav__menu-item': true,
                      'slide-nav__menu-item--has-button': child.children.length,
                      'slide-nav__menu-item--active': child.currentPage
                    }"
                  >
                    <div
                      v-if="!child.href"
                      class="slide-nav__link slide-nav__link--block"
                      :class="{'slide-nav__link--active': child.currentPage}"
                      @click="setActiveItem(child.id, 'slide-in-nav')"
                    >{{child.displayName}}</div>
                    <a
                      v-else
                      class="slide-nav__link"
                      :class="{'slide-nav__link--active': child.currentPage}"
                      :href="child.href"
                      :target="child.target"
                    >{{child.displayName}}</a>
                    <button
                      class="slide-nav__button"
                      v-if="child.children.length"
                      @click="setActiveItem(child.id, 'slide-in-nav')"
                    >
                      <chevron-right/>
                    </button>
                  </li>
                </ul>
              </li>
            </transition>
          </ul>
          <ul
            v-else
            key="root"
            ref="menuItemList"
            class="slide-nav__list"
          >
            <template
              v-for="item in rootItems"
            >
              <li
                :class="{
                  'slide-nav__menu-item': true,
                  'slide-nav__menu-item--has-button': item.children.length,
                  'slide-nav__menu-item--active': item.currentPage
                }"
              >
                <div
                  v-if="!item.href"
                  class="slide-nav__link slide-nav__link--block"
                  :class="{'slide-nav__link--active': item.currentPage}"
                  @click="setActiveItem(item.id, 'slide-in-nav')"
                >{{item.displayName}}</div>
                <a
                  v-else
                  class="slide-nav__link"
                  :class="{'slide-nav__link--active': item.currentPage}"
                  :href="item.href"
                  :target="item.target"
                >{{item.displayName}}</a>
                <button
                  class="slide-nav__button"
                  v-if="item.children.length"
                  @click="setActiveItem(item.id, 'slide-in-nav')"
                >
                  <chevron-right/>
                </button>
              </li>
            </template>
          </ul>
        </transition>
      </div>
    </div>
  `,
    data() {
        return {
            expanded: false,
            menuTree: [],
            activeItem: {},
            transitionName: '',
            isInFirstTime: true,
        };
    },
    watch: {
        activeItem: 'populateActiveItem',
    },
    mounted() {
        // new HttpRequest(
        //   {
        //     method: "POST",
        //     url: devProdPath("http://localhost:3000/flatmenu", this.url),
        //     data: { currentPath: window.location.pathname }
        //   },
        //   (err, result) => {
        //     debugger;
        //     if (result) {
        //       this.menuTree = result;
        //       this.setActiveItemInitial();
        //     } else {
        //       $(this.$refs.navWrapper).addClass("slide-nav--empty");
        //     }
        //   }
        // );
        this.getList((err, result) => {
            if (result) {
                this.menuTree = result;
                this.setActiveItemInitial();
            } else {
                $(this.$refs.navWrapper).addClass('slide-nav--empty');
            }
        });
    },
    computed: {
        rootItems() {
            return this.menuTree.filter((item) => item.parentId === null);
        },
    },
    updated() {
        this.$nextTick(function () {
            if (!this.isInFirstTime) return;
            this.calcHeight(this.$refs.menuItemList);
            this.isInFirstTime = false;
        });
    },
    methods: {
        populateActiveItem(val, oldVal) {
            if (!val.children) return;
            val.children = val.children.map((id) => {
                return this.menuTree.find((item) => item.id == id);
            });
        },
        setActiveItemInitial() {
            const active = this.menuTree.find((item) => item.currentPage);
            if (active && active.children.length)
                this.activeItem = Object.assign({}, active);
            else if (active && !active.children.length)
                this.setActiveItem(active.parentId, false);
            else this.activeItem = {};
        },
        setActiveItem(id, transitionName) {
            this.transitionName = transitionName ? transitionName : '';
            const active = this.menuTree.find((item) => item.id == id);
            active
                ? (this.activeItem = Object.assign({}, active))
                : (this.activeItem = {});
        },
        isSamePath(pathname) {
            if (!pathname) return false;
            return (
                window.location.pathname.replace(/\//g, '') ==
                pathname.replace(/\//g, '')
            );
        },
        getList(callback) {
            const _this = this;
            $.ajax({
                url: this.url,
                data: {
                    menuId: _this.menuId,
                    currentPath: window.location.pathname,
                },
                type: 'POST',
                dataType: 'json',
                success(response) {
                    if (typeof callback == 'function') {
                        return callback.call(_this, null, response);
                    }
                },
                error(xhr, ajaxOptions, trowError) {
                    if (typeof callback == 'function') {
                        return callback.call(_this, trowError);
                    }
                },
            });
        },
        calcHeight(el) {
            const height = $(el).outerHeight();
            if (height > 0) $(this.$refs.navWrapper).css({ height });

            setTimeout(() => $(document).trigger('slide-nav-refresh'), 200);
        },
    },
});

function init(selector) {
    const el = document.querySelector(selector);
    if (el) {
        const url = el.getAttribute('data-get-menu-items-from') || null;
        const showMobileHeader =
            el.getAttribute('data-show-mobile-header') || false;
        const menuId = el.getAttribute('data-menu-id') || null;
        new Vue({
            el: selector,
            template: `<slide-nav url="${url}" :show-mobile-header="${showMobileHeader}" :menu-id="'${menuId}'"/>`,
        });
    }
}

// class HttpRequest {
//   constructor(options, callback = function() {}) {
//     this.defaults = {
//       method: "GET",
//       url: "",
//       data: null
//     };
//     this.settings = Object.assign(this.defaults, options);
//     this.callback = callback;
//     this.result;
//     this.init();
//   }

//   prepareData(json) {
//     return Object.keys(json)
//       .map(function(key) {
//         return encodeURIComponent(key) + "=" + encodeURIComponent(json[key]);
//       })
//       .join("&");
//   }

//   init() {
//     const xhr = (this.xhr = new XMLHttpRequest());
//     xhr.open(this.settings.method, this.settings.url, true);
//     xhr.setRequestHeader(
//       "Content-type",
//       "application/x-www-form-urlencoded; charset=UTF-8"
//     );

//     xhr.onreadystatechange = () => {
//       if (xhr.readyState != 4) return;

//       if (xhr.status != 200) {
//         return this.callback.call(null, xhr);
//       } else {
//         let result;
//         try {
//           result = JSON.parse(xhr.responseText);
//           return this.callback.call(null, null, result);
//         } catch (err) {
//           console.log(err);
//           return this.callback.call(null, err);
//         }
//       }
//     };
//     if (this.settings.data) xhr.send(this.prepareData(this.settings.data));
//     else xhr.send();
//   }
// }

// const httpRequest = options => {
//   const xhr = new XMLHttpRequest();
//   let result;

//   xhr.open("GET", "phones.json", true);

//   xhr.send(options.data);

//   xhr.onreadystatechange = function() {
//     if (xhr.readyState != 4) return;

//     if (xhr.status != 200) {
//       console.log(xhr.status + ": " + xhr.statusText);
//     } else {
//       try {
//         result = JSON.parse(xhr.responseText);
//       } catch (err) {
//         console.log(err);
//         return null;
//       }
//     }
//   };
// };

export default init;
